import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./comment.html";
import { i18nStore, selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';
class CommentTile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.comment = void 0;
    this.isMobile = false;
    this.sharedLabel = void 0;
  }
  get hasProfileLink() {
    return this.comment.user.profileLink;
  }
  get generatedId() {
    return CommentTile.idCounter++;
  }
  get commentUserName() {
    return i18nStore.getState().i18n.shared.userName({
      FIRST_NAME: this.comment?.user?.firstName ?? '',
      LAST_NAME: this.comment?.user?.lastName ?? ''
    });
  }
  get avatarLinkAriaLabel() {
    return i18nStore.getState().i18n.shared.avatarLinkAriaLabel({
      USER_NAME: this.commentUserName
    });
  }
  get defaultAvatarAltText() {
    return this.sharedLabel.defaultAvatarAltText;
  }
  /*LWC compiler v7.1.3*/
}
CommentTile.idCounter = 1;
_registerDecorators(CommentTile, {
  publicProps: {
    comment: {
      config: 0
    },
    isMobile: {
      config: 0
    }
  },
  wire: {
    sharedLabel: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(CommentTile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;